import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class DistrictService extends Service{
    constructor() {
        super();
        this.baseURL = 'district';
    }

    findByCityId(cityId) {
        return fetch(SERVER_URL + this.baseURL + '/' + cityId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}